import "./tailwind-generated.css";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";
import { RouterProvider } from "react-router-dom";
import { createBrowserRouter } from "@datadog/browser-rum-react/react-router-v6";
import { HelmetProvider } from "react-helmet-async";

import { MainLayout } from "./layouts/MainLayout";
import { HomePage, SchoolPage } from "./pages";
import { getEnvironment } from "./lib/helpers/getEnvironment";

datadogRum.init({
  applicationId: "26fb153e-4925-4208-8480-1a54bab9561c",
  clientToken: "pub31830d0f580a8608de84005501a58187",
  site: "datadoghq.com",
  service: "se-play-locallive-sep-react-web",
  env: getEnvironment(),
  version: "1.0.0",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 0,
  defaultPrivacyLevel: "mask-user-input",
  plugins: [reactPlugin({ router: true })],
  trackUserInteractions: true,
  allowedTracingUrls: [
    /^https:\/\/[^/]+\.locallive\.tv/,
    /^https:\/\/[^/]+\.sportsengineplay\.com/,
  ],
});

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <MainLayout>
        <HomePage />
      </MainLayout>
    ),
  },
  {
    path: "/schools/:id",
    element: (
      <MainLayout>
        <SchoolPage />
      </MainLayout>
    ),
  },
]);

function App() {
  return (
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  );
}

export default App;
